import { getAction } from "@/api/manage";
import { mixinDevice } from "@/utils/mixin.js";
import "@/assets/less/animation.css";
import LightBox from 'vue-image-lightbox';
require('vue-image-lightbox/dist/vue-image-lightbox.min.css');
export default {
  mixins: [mixinDevice],
  components: {
    LightBox: LightBox
  },
  data: function data() {
    return {
      tenantConfig: {},
      videoDataSource: [],
      picDataSource: [],
      videoVisible: false,
      currentVideo: {},
      swiperOptions: {
        speed: 800,
        effect: this._isMobile() ? "fade" : "coverflow",
        //"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）
        slidesPerView: 3,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 20,
          stretch: -100,
          depth: 700,
          modifier: 1,
          slideShadows: true
        },
        //显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        //自动轮播
        autoplay: {
          delay: 3000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: true
        },
        //开启循环模式
        loop: true
      },
      oldEventPic: [],
      lightBoxMedia: []
    };
  },
  created: function created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
    this.getPicList();
    this.getVideoList();
  },
  methods: {
    getVideoList: function getVideoList() {
      var _this = this;
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: 5,
        pageSize: 12
      }).then(function (res) {
        if (res.success) {
          _this.videoDataSource = res.result.records;
        }
      });
    },
    getPicList: function getPicList() {
      var _this2 = this;
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: 10,
        pageSize: 10
      }).then(function (res) {
        if (res.success) {
          _this2.picDataSource = res.result.records;
          _this2.oldEventPic = _this2.picDataSource.map(function (i) {
            return {
              img: i.cmsCover_url,
              href: "#"
            };
          });
        }
      });
    },
    toVideoDetail: function toVideoDetail(item) {
      this.currentVideo = item;
      this.videoVisible = true;
      getAction("/teaching/teachingCms/getCmsDetail?id=" + item.id);
    },
    toPicDetail: function toPicDetail(item) {
      //使阅读量+1
      getAction("/teaching/teachingCms/getCmsDetail?id=" + item.id);
      var that = this;
      var fileNames = [];
      if (item.extraFilename) {
        fileNames = JSON.parse(item.extraFilename);
        console.log(fileNames);
      }
      if (item.extraFile) {
        this.lightBoxMedia = item.extraFile.split(",").map(function (f) {
          var fn = "";
          if (f in fileNames) {
            fn = fileNames[f];
          }
          return {
            thumb: that.getQiniuUrl(f),
            src: that.getQiniuUrl(f),
            caption: fn
          };
        });
        this.$refs.lightbox.showImage(0);
      } else {
        //this.$message.warning("没有图像")
      }
    },
    getQiniuUrl: function getQiniuUrl(text) {
      if (!text) {
        this.$message.warning("未知的文件");
        return;
      }
      if (text.indexOf(",") > 0) {
        text = text.substring(0, text.indexOf(","));
      }
      if (text.startsWith("http")) {
        return text;
      }
      return this.tenantConfig.qiniuDomain + "/" + text;
    }
  }
};